/* Sync layer — pulls server state into IndexedDB on login/reconnect, pushes
 * the local sync_queue back up. Last-write-wins on updated_at. */
import { endpoints } from "./api";
import { getDB, getQueue, clearQueueItems, putAll, STORES } from "./db";

export async function pullFromServer() {
    try {
        const { data } = await endpoints.pullSync();
        await putAll(STORES.jobs, data.jobs || []);
        await putAll(STORES.clients, data.clients || []);
        await putAll(STORES.documents, data.documents || []);
        await putAll(STORES.rate_schedules, data.rate_schedules || []);
        return { ok: true, counts: {
            jobs: (data.jobs || []).length,
            clients: (data.clients || []).length,
            documents: (data.documents || []).length,
            schedules: (data.rate_schedules || []).length,
        }};
    } catch (e) {
        return { ok: false, error: e?.message || "pull failed" };
    }
}

export async function flushQueue() {
    const items = await getQueue();
    if (!items.length) return { ok: true, flushed: 0 };
    const grouped = { jobs: [], clients: [], documents: [] };
    const keys = [];
    for (const it of items) {
        if (grouped[it.kind]) grouped[it.kind].push(it.payload);
        keys.push(it.key);
    }
    try {
        await endpoints.pushSync(grouped);
        await clearQueueItems(keys);
        return { ok: true, flushed: items.length };
    } catch (e) {
        return { ok: false, error: e?.message || "push failed" };
    }
}

export async function fullSync() {
    const pushed = await flushQueue();
    const pulled = await pullFromServer();
    return { pushed, pulled };
}
